import { Box, Stack, Text } from '@chakra-ui/react'

import { isSummerCampInProgress, SUMMER_CAMP_ICON } from '@/client/services/summerCamp'
import { getSummerCampUrl } from '@/client/services/url'

import ShwLink from '@/components/ShwLink'
import Icon from '@/components/UI/Icon/Icon'

export default function SummerCampSeriesBanner({
  text = 'This series is part of Schoolhouse Summer Camp!',
  linkText = 'Explore Summer Camp',
}: {
  text?: string
  linkText?: string
}): JSX.Element | null {
  if (!isSummerCampInProgress()) {
    return null
  }

  return (
    <Box bgColor="primary.subtle" borderRadius={8} p={4}>
      <Stack direction="row" fontWeight="bold" alignItems="center">
        <Icon faIcon={SUMMER_CAMP_ICON} color="primary.fg" />
        <Text>
          {text}{' '}
          <ShwLink href={getSummerCampUrl()} _hover={{ color: 'primary.subtle' }}>
            {linkText}
          </ShwLink>
        </Text>
      </Stack>
    </Box>
  )
}
